<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" :params="params" />
	<el-radio-group v-else v-model="value" :disabled="disabled">
		<template v-if="isButton">
			<el-radio-button
				v-for="item in params"
				:key="item.value"
				:label="item.value"
				:border="border"
				v-bind="getExtraAttrs(item)"
			>
				{{ item.label }}
			</el-radio-button>
		</template>
		<template v-else>
			<el-radio
				v-for="item in params"
				:key="item.value"
				:label="item.value"
				:border="border"
				v-bind="getExtraAttrs(item)"
			>
				{{ item.label }}
			</el-radio>
		</template>
	</el-radio-group>
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: string;
		isButton?: boolean;
		border?: boolean;
		params: { label: string; value: string; [key: string]: any }[];
		disabled?: boolean;
		showDisabledText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const getExtraAttrs = (item: any) => {
		const { label: _label, value: _value, ...rest } = item;
		return rest;
	};

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped>
	.show-value {
		display: flex;
		gap: 3px;
		flex-wrap: wrap;
	}
</style>
